import React, { useEffect, useState } from "react";
import styles from "./GeneralInformation.module.css";
import { Col, Row, Select, Spin, Upload } from "antd";
import { Controller } from "react-hook-form";
import CustomTextfield from "../../../../../../common/input/custom-textfield/custom-textfield";
import CustomSelect from "../../../../../../common/input/custom-select/custom-select";
import { curriculumType, ownershipStatusType, schoolType } from "../../../../../../constants/common";
import CustomDatepicker from "../../../../../../common/input/custom-datepicker/custom-datepicker";
import { UploadOutlined } from "@ant-design/icons";
import { getSchoolListToLink } from "../../../../../../services/institution";

const GeneralInformation = ({ control }) => {
  const PAGE_SIZE = 10;
  const [isSchoolListLoading, setIsSchoolListLoading] = useState(false);
  const [schoolListPage, setSchoolListPage] = useState(1);
  const [hasMoreSchool, setHasMoreSchool] = useState(false);
  const [schoolList, setSchoolList] = useState([]);

  useEffect(() => {
    fetchSchoolList()
  }, []);

  const fetchSchoolList = async (page = 1, append = false) => {
    try {
      setIsSchoolListLoading(true);
      const params = {
        page: page,
        pageSize: PAGE_SIZE,
        is_parent: true,
      };
      const response = await getSchoolListToLink(params);
      if (response?.data?.status) {
        const schools = response?.data?.data?.schools || [];
        const totalCount = response.data?.data?.totalRecords || 0;

        const reachedEnd = page * PAGE_SIZE >= totalCount;
        setHasMoreSchool(!reachedEnd);
        setSchoolList((prev) => (append ? [...prev, ...schools] : schools));
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsSchoolListLoading(false);
    }
  };

  return (
    <Row gutter={[32, 20]}>
      <Col span={12}>
        <Controller
          name="institution_name"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="institution_name"
              label="School Name"
              showRequired
              labelColor="#171717"
              placeholder="Type School name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="prinicipal_first_name"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="prinicipal_first_name"
              label="First Name of Principal/Head"
              showRequired
              labelColor="#171717"
              placeholder="Enter first name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="prinicipal_middle_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="prinicipal_middle_name"
              label="Middle Name of Principal/Head"
              showOptional
              labelColor="#171717"
              placeholder="Enter middle name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="prinicipal_last_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="prinicipal_last_name"
              label="Last Name of Principal/Head"
              showOptional
              labelColor="#171717"
              placeholder="Enter last name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="deputy_prinicipal_first_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="deputy_prinicipal_first_name"
              label="First Name of Deputy Principal/Head"
              showOptional
              labelColor="#171717"
              placeholder="Enter first name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="deputy_prinicipal_middle_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="deputy_prinicipal_middle_name"
              label="Middle Name of Deputy Principal/Head"
              showOptional
              labelColor="#171717"
              placeholder="Enter middle name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="deputy_prinicipal_last_name"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="deputy_prinicipal_last_name"
              label="Last Name of Deputy Principal/Head"
              showOptional
              labelColor="#171717"
              placeholder="Enter last name"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="registration_number"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="registration_number"
              label="Registration/Accreditation Number"
              labelColor="#171717"
              placeholder="Enter number"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="curriculum"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="curriculum"
              label="Curriculum"
              showRequired
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {curriculumType.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="school_type"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="school_type"
              label="School Type"
              showRequired
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {schoolType.map((item, index) => (
                <Select.Option key={index} value={item?.value}>
                  {item?.label}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="ownership_type"
          control={control}
          rules={{ required: true }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="ownership_type"
              label="Ownership Type"
              showRequired
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            >
              {ownershipStatusType?.map((item, index) => (
                <Select.Option key={index} value={item}>
                  {item}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="established_date"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomDatepicker
              id="established_date"
              label="Date Established"
              showOptional
              labelColor="#171717"
              placeholder="DD-MM-YYYY"
              size="large"
              value={value}
              onChange={onChange}
              style={{ height: "40px", width: "100%" }}
              status={error ? "error" : ""}
              prefix={
                <img
                  src="/assets/images/calendarOutlined.svg"
                  style={{ marginRight: 4 }}
                  alt="calendar"
                />
              }
            />
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="vision"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomTextfield
              id="vision"
              label="Motto / Vision"
              showOptional
              labelColor="#171717"
              placeholder="Type motto"
              size="large"
              value={value}
              onChange={onChange}
              status={error ? "error" : ""}
            />
          )}
        />
      </Col>

      <Col span={12}>
        <label
          htmlFor="file"
          style={{
            display: "block",
            marginBottom: 8,
            color: "#171717",
            fontWeight: 400,
          }}
        >
          <span>Upload School Logo</span>
          <span style={{ color: "#8C8C8C" }}>{" (Optional)"}</span>
        </label>
        <Controller
          name="institution_logo"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Upload
              beforeUpload={(file) => {
                // setFileName(file.name);
                onChange(file);
                return false;
              }}
              showUploadList={false}
              accept=".jpg,.png"
              status={error ? "error" : ""}
              className={styles.common_input_styles}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  border: `1px solid ${error ? "red" : "#D0D5DD"} `,
                  paddingInline: 16,
                  borderRadius: 8,
                  cursor: "pointer",
                }}
              >
                <div style={{ color: "#8C8C8C", fontFamily: "Inter" }}>
                  {value?.name ?? "Select a file to Upload"}
                </div>
                <UploadOutlined style={{ color: "#8C8C8C", width: "auto" }} />
              </div>
            </Upload>
          )}
        />
      </Col>

      <Col span={12}>
        <Controller
          name="linked_school_id"
          control={control}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomSelect
              id="linked_school_id"
              label="Linked School"
              labelColor="#171717"
              placeholder="--Select--"
              size="large"
              value={value}
              onChange={onChange}
              showOptional
              allowClear
              onClear={() => {
                setSchoolListPage(1);
                fetchSchoolList(1);
              }}
              onPopupScroll={(e) => {
                const el = e.target;
                const reachedBottom =
                  el.scrollTop + el.offsetHeight >= el.scrollHeight - 10;

                if (reachedBottom && !isSchoolListLoading && hasMoreSchool) {
                  const nextPage = schoolListPage + 1;
                  setSchoolListPage(nextPage);
                  fetchSchoolList(nextPage, true);
                }
              }}
              notFoundContent={
                isSchoolListLoading ? <Spin size="small" /> : null
              }
              status={error ? "error" : ""}
            >
              {schoolList?.map((item, index) => (
                <Select.Option key={item?.id || index} value={item?.id}>
                  {item?.institution_name}
                </Select.Option>
              ))}
            </CustomSelect>
          )}
        />
      </Col>
    </Row>
  );
};

export default GeneralInformation;
